import React, { Component } from "react";
import { connect } from "react-redux";
import { assessmentActions, userActions } from "../../../_actions";
import Dashboard from "../Dashboard/Dashboard";
import Heading from "../../AdminPanel/Component/UI/Heading";
import moment from "moment";
import ProgressTab from "../Component/ProgressTab";
import EmployeeTable from "../Component/EmployeeTable";
import { MdOutlineArrowBack } from "react-icons/md";



class AssessmentCodeList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      crrProductId: this.props.match.params.id,
      searchQuery: "",
      showMsg2: false,
      code: "",
      pageNo: 1,
      size: 10,
      keyWord: ""
    };
  }

  componentDidMount() {
    this.props.dispatch(assessmentActions.userAssessmentUserProfile());

    this.getList(1, 10);
  }

  logout = () => {
    this.props.dispatch(assessmentActions.AssessmentUserLogout(this.props));
  };

  switchToSelf = () => {
    this.props.dispatch(userActions.userCoachSwitchLogin({}, this.props));
  };

  handleNameChange = (id, text) => {
    this.setState((prevState) => ({
      tableData: prevState.tableData.map((row) =>
        row.id === id ? { ...row, name: text } : row
      ),
    }));
  };


  copyToClipboard = (otpCode) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(otpCode);
    }
    this.setState({
      showMsg2: true,
      crrCodeCopied: otpCode
    });
    setTimeout(() => {
      this.setState({ showMsg2: false, crrCodeCopied: "" });
    }, 3000);
  };


  getList = (page, size) => {
    let data = {
      productId: this.state.crrProductId,
      keyWord: this.state.keyWord,
      pageNo: page,
      size: size
    }
    this.props.dispatch(assessmentActions.AllPurchasedCodes(data));
  }


  handleSearch = (event) => {
    event.preventDefault();
    let { value } = event.target;
    this.setState({ keyWord: value, offset: 0 }, () => {
      this.getList(1, 10)
    });
  }



  renderStatusBadge = (status) => {
    switch (status) {
      case "Pending":
        return (
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-gray-200/70 text-slate-700">
            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            Pending
          </span>
        );
      case "In Progress":
        return (
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-indigo-100 text-indigo-600">
            <svg className="w-3.5 h-3.5 animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
            In Progress
          </span>
        );
      case "Completed":
        return (
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-emerald-100 text-emerald-700">
            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
            </svg>
            Completed
          </span>
        );
      default:
        return null;
    }
  };


  render() {

    let { showMsg2, code, } = this.state;
    const { assessment } = this.props;
    const { AllPurchasedCodesData, AllPurchasedCodesTotal, userAssessmentUserProfileData } = assessment;

    const getPeriod = () => {
      const hour = moment().hour();
      if (hour >= 5 && hour < 12) return "Morning";
      if (hour >= 12 && hour < 17) return "Afternoon";
      if (hour >= 17 && hour < 21) return "Evening";
      return "Night";
    };

    let userDetails = {
      name: userAssessmentUserProfileData?.name ?? "",
      email: userAssessmentUserProfileData?.email ?? "",
      period: getPeriod(),
    };

    let { loading } = assessment;


    const codeList = AllPurchasedCodesData && AllPurchasedCodesData.length > 0 ?
      AllPurchasedCodesData.map((row) => ({
        id: row.id,
        name: row.name,
        code: String(row.otpCode || ""),
        used: row && row.name ? true : false,
        status: row.isComplete ? "Completed" : "Pending"
      })) : [];


    // console.log("codeList--->", codeList)

    const columns = [
      { label: "Name", col: "name" },
      { label: "Code", col: "code" },
      { label: "Used", col: "used" },
      { label: "Status", col: "status" },
      // { label: "Action", col: "action" },
    ];

    return (
      <Dashboard userDetails={userDetails} logout={this.logout} switchToSelf={this.switchToSelf} loading={loading}>
        <div className="w-full mx-auto p-8">
          <ProgressTab currentStep={1} history={this.props.history} />
          <div className="border-b border-slate-300" />
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 py-5">
            <div className="flex items-center gap-3">
              <div onClick={() => this.props.history.goBack()} className="p-3 bg-gray-100 rounded-full cursor-pointer hover:bg-white border hover:border-indigo-500">
                <MdOutlineArrowBack size={25} className="text-gray-600" />
              </div>
              <div>
                <Heading className="text-2xl font-medium" title="Assessment Code List" />
                <p className="mt-1 text-sm text-gray-600">
                  Create, manage, and track assessment codes for competency surveys across your organization.
                </p>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <div className="relative">
                <svg className="w-4 h-4 absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
                <input
                  type="text"
                  placeholder="Search"
                  value={this.state.keyWord}
                  onChange={this.handleSearch}
                  className="pl-10 pr-4 py-2 w-64 bg-white border border-slate-200 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 text-slate-700 placeholder-slate-400"
                />
              </div>
              <button onClick={() => this.props.history.push("/assessment/products")} className="px-5 py-2 rounded-md bg-gradient-to-r from-[#673AB7] to-[#1976D2] text-white font-semibold text-base transition-colors duration-200 shadow-md shadow-indigo-100">Get Assessment Code</button>
            </div>

          </div>

          <EmployeeTable
            columns={columns}
            list={codeList}
            totalCount={AllPurchasedCodesTotal}
            getEmpList={this.getList}
            generateReportBn={this.generateReportBn}
            gotoAddJobDetails={this.gotoAddJobDetails}
            copyToClipboard={this.copyToClipboard}
          />

          {showMsg2 && (
            <div className="fixed whitespace-nowrap z-20 top-24 right-0 p-6 py-4 rounded-l-lg shadow-md border-l-4 border-green-500 text-[#3D405B] bg-white ">
              <p> Assessment Code Copied !</p>
              <h2 className="text-lg font-medium">{code}</h2>
            </div>
          )}

        </div>
      </Dashboard>
    );
  }
}

function mapStateToProps(state) {
  const { loggingIn } = state.authentication;
  const { questions, users, assessment } = state;
  return {
    loggingIn,
    questions,
    users,
    assessment,
  };
}

export default connect(mapStateToProps)(AssessmentCodeList);